module.exports = __webpack_public_path__ + "static/media/measure-example.e8ac0724.gif";